import { cloneDeep } from "lodash";

export const setActiveContentMultiChoiceOptionValue = ({
  contents,
  activeContentId,
  data,
}) => {
  return contents.map((content) => {
    if (content.id === activeContentId) {
      content.options = content.options.map((option) => {
        if (option.id === data.id) {
          option.value = data.value;
        }

        return option;
      });
    }

    return cloneDeep(content);
  });
};

export default setActiveContentMultiChoiceOptionValue;
